import { ParentModel } from '@modules/parent/parent-model';

const fields = new ParentModel().fields();

export default [
  fields.gender,
  fields.children,
  fields.country,
  fields.email,
  fields.role,
  fields.birthdate,
];
